import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'tooltip-component',
  template: ` <div class="custom-tooltip" [style.background-color]="color" [style.width]="'auto'"  [style.min-width]="'40vw'"  [style.max-width]="'90vw'" [style.height]="'auto'" > 
    <p>
      <span [innerHTML]="data.comment | nl2br"></span>
    </p>
   
  </div>`,
  styles: [
    `
      :host {
        position: absolute;
        top: -150px;
        width: 150px;
        height: 70px;
        pointer-events: none;
        transition: opacity 1s;
      }

      :host.ag-tooltip-hiding {
        opacity: 0;
      }

      .custom-tooltip p {
        margin: 5px;
        white-space: wrap;
        text-wrap: stable;
      }

      .custom-tooltip p:first-of-type {
        font-weight: bold;
      }
    `,
  ],
})
export class CustomTooltip implements ITooltipAngularComp {
   params: { color: string } & ITooltipParams;
   data: any;
   color: string;

  agInit(params: { color: string } & ITooltipParams): void {
    this.params = params;

    this.data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
    this.color = this.params.color || 'white';
  }
}